import { render, staticRenderFns } from "./want-more.vue?vue&type=template&id=918a3abc&scoped=true"
import script from "./want-more.vue?vue&type=script&lang=js"
export * from "./want-more.vue?vue&type=script&lang=js"
import style0 from "./want-more.vue?vue&type=style&index=0&id=918a3abc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "918a3abc",
  null
  
)

export default component.exports